import * as types from "./mutation-types";

export default {
  [types.SET_STRATEGIES](state, payload) {
    state.strategies = { accounts: payload.accounts };
  },

  [types.SET_INVESTMENT](state, payload) {
    state.investment = payload;
    state.order_msg = "";
  },

  [types.SET_LOGS_LIST](state, payload) {
    payload.data.forEach(function (elem) {
      state.logs.push(elem);
    });
  },

  [types.DESTROY_LOGS](state) {
    state.logs = [];
  },

  [types.SET_ORDERS](state, payload) {
    state.order_msg = payload.data.msg;
    payload.data.forEach(function (elem) {
      state.investment.orders.push(elem);
    });
  },

  [types.SET_ORDERS_INFO](state, payload) {
    state.orders = payload;
  },

  [types.SET_LIMIT_LOGS](state, payload) {
    state.limit_logs = payload;
  },

  [types.SET_DATE_RANGE](state, payload) {
    state.date_range = payload;
  },

  [types.SET_MSG_LOGS](state, payload) {
    state.logs_msg = paylaod;
  },

  [types.SET_MSG](state, payload) {
    state.strategies_msg = payload;
  },
};
